import React, { useState } from "react";
import { NavLink, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "../../lib/AuthContext";
import { LayoutDashboard, Newspaper, Image, Users, Trophy, Sparkles, Settings, LogOut, Menu, X, Mail, FileText, UserPlus, GraduationCap, Building2, Calendar, Megaphone } from "lucide-react";

const LINKS = [
  { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/news", label: "Berita", icon: Newspaper },
  { to: "/admin/announcements", label: "Pengumuman", icon: Megaphone },
  { to: "/admin/ppdb", label: "Pendaftar PPDB", icon: UserPlus },
  { to: "/admin/teachers", label: "Guru & Staf", icon: Users },
  { to: "/admin/achievements", label: "Prestasi", icon: Trophy },
  { to: "/admin/extracurriculars", label: "Ekstrakurikuler", icon: Sparkles },
  { to: "/admin/gallery", label: "Galeri", icon: Image },
  { to: "/admin/facilities", label: "Fasilitas", icon: Building2 },
  { to: "/admin/events", label: "Kalender", icon: Calendar },
  { to: "/admin/documents", label: "Dokumen", icon: FileText },
  { to: "/admin/messages", label: "Pesan Kontak", icon: Mail },
  { to: "/admin/settings", label: "Pengaturan Sekolah", icon: Settings },
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const doLogout = () => { logout(); navigate("/admin"); };

  return (
    <div className="min-h-screen bg-slate-100 flex">
      <aside data-testid="admin-sidebar" className={`fixed inset-y-0 left-0 z-40 w-64 bg-[#071224] text-white transform ${open ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0 transition-transform duration-200`}>
        <div className="h-16 flex items-center gap-3 px-5 border-b border-white/10">
          <div className="w-9 h-9 rounded-lg bg-amber-500 text-[#0B1D3A] flex items-center justify-center"><GraduationCap className="w-5 h-5" /></div>
          <div>
            <div className="font-serif font-bold text-sm">SMAS YPK 2 BIAK</div>
            <div className="text-[10px] tracking-widest text-amber-400 font-semibold">ADMIN CMS</div>
          </div>
        </div>
        <nav className="p-3 space-y-1 overflow-y-auto h-[calc(100vh-9rem)]">
          {LINKS.map((l) => {
            const Icon = l.icon;
            return (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-semibold transition-colors ${isActive ? "bg-amber-500 text-[#0B1D3A]" : "text-slate-300 hover:bg-white/5 hover:text-white"}`
                }
              >
                <Icon className="w-4 h-4" /> {l.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="absolute bottom-0 inset-x-0 border-t border-white/10 p-3">
          <div className="text-xs text-slate-400 px-3 mb-2">{user?.email}</div>
          <button data-testid="admin-logout" onClick={doLogout} className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-semibold text-red-300 hover:bg-red-500/10"><LogOut className="w-4 h-4" /> Keluar</button>
        </div>
      </aside>

      {open && <div className="fixed inset-0 bg-black/40 z-30 lg:hidden" onClick={() => setOpen(false)} />}

      <div className="flex-1 lg:ml-64">
        <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-5 sticky top-0 z-20">
          <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="admin-mobile-toggle">{open ? <X /> : <Menu />}</button>
          <div className="flex items-center gap-3 ml-auto">
            <div className="text-right">
              <div className="text-sm font-semibold text-[#0B1D3A]">{user?.name}</div>
              <div className="text-xs text-slate-500 uppercase tracking-wider">{user?.role}</div>
            </div>
            <div className="w-9 h-9 rounded-full bg-amber-500 text-[#0B1D3A] flex items-center justify-center font-bold">{(user?.name || "A")[0]}</div>
          </div>
        </header>
        <main className="p-5 lg:p-8">
          <Outlet />
          {children}
        </main>
      </div>
    </div>
  );
}
